<script>

    import { UserStore, ModalStore } from '../stores'

    import Value from '../$components/value.svelte'
    import Button from '../$components/button.svelte'

</script>

{#if $UserStore}
    <div class="columns">
        <div class="column">
            <div class="buttons">
                <Button on:click={() => ModalStore.set('UserUpdatePassword')} icon="lock" text="Contraseña" color="primary" size="small" />
                <Button on:click={() => ModalStore.set('UserUpdateEmail')} icon="envelope" text="Correo" color="primary" size="small" />
                <Button on:click={() => UserStore.modalUpdate($UserStore)} icon="info" text="Información" color="primary" size="small" />
            </div>
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Nombre" value={ $UserStore.firstName } />
        </div>
        <div class="column">
            <Value label="Apellido" value={ $UserStore.lastName } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="RFC" value={ $UserStore.rfc || 'Sin información' } />
        </div>
        <div class="column">
            <Value label="Empresa" value={ $UserStore.company || 'Sin información' } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Correo" value={ $UserStore.email } />
        </div>
        <div class="column">
            <Value label="Teléfono" value={ $UserStore.phone || 'Sin información' } />
        </div>
    </div>
{/if}